const bleDeviceConnectionStatus = {
    CONNECTED: 'connected',
    CONNECTING: 'connecting',
    DISCONNECTING: 'disconnecting',
    DISCONNECTED: 'disconnected'
}

export default bleDeviceConnectionStatus;